import VuetableCheckboxStore from '../store';

module.exports = function() {
    if (this.opts.checkbox) {
        const module = `${this.name}_CHECKBOX`;
        if (!this.$store.hasModule(module)) {
            this.$store.registerModule(
                module,
                $.extend(true, {}, VuetableCheckboxStore),
            );
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/methods/register-checkbox-module.js